import React from 'react'
import { ToastMessageState } from '../../redux/reducers/toast'

export const Toast: React.FunctionComponent<ToastMessageState> = ({ visible, message }) => (
	<div className={`${visible ? 'visible' : ''} toast`}><p>{message.toUpperCase()}</p></div>
)

export default Toast;

